import { Link } from 'react-router-dom'
import { FileQuestion } from 'lucide-react'
import { CmdEmptyState } from '@/components/layout/CmdEmptyState'
import { Button } from '@/components/ui/button'
import { paths } from '@/routes/paths'

/** Authenticated catch-all — visible error instead of a silent dashboard redirect. */
export function NotFoundPage() {
  return (
    <main id="main-content" className="px-4" data-testid="not-found-page">
      <CmdEmptyState
        icon={<FileQuestion className="h-8 w-8" aria-hidden="true" />}
        title="Page not found"
        description="This link does not match a screen in WingCaster yet. Check the URL or return to your dashboard."
        action={
          <Button asChild variant="default">
            <Link to={paths.dashboard}>Back to dashboard</Link>
          </Button>
        }
      />
    </main>
  )
}
